import { FC } from "react";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import { ClientSearchHeaderWrapper } from "./ClientSearchHeader.style";
import { useNavigate } from "react-router-dom";
import { MODULE_PERMISSIONS, PAGE_URLS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { clientSearchSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";

const pageId = "client-search";

export const ClientSearchHeader: FC = () => {
  const navigate = useNavigate();
  const { fetchLabel, pageTitle } = useSiteCore();

  const handleNavigate = () => {
    navigate(PAGE_URLS.CREATE_CLIENT, {
      state: { from: PAGE_URLS.SEARCH_CLIENT },
    });
  };
  return (
    <ClientSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <PermissionWrapper permission={MODULE_PERMISSIONS.CREATE_CLIENT}>
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={handleNavigate}
              className="header-right-button"
              id={`${pageId}-newClient`}
              data-testid="new-client"
            >
              {fetchLabel(
                clientSearchSiteCoreKeys.header,
                clientSearchSiteCoreKeys.headerNewClient,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </ClientSearchHeaderWrapper>
  );
};
